import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Box, Button } from '@mui/material';

export default function DateRangePicker({ startDate, endDate, onStartDateChange, onEndDateChange, onApply }) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>             
                <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={onStartDateChange}
                    slotProps={{ textField: { size: 'small' } }}
                />
                <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={onEndDateChange}
                    slotProps={{ textField: { size: 'small' } }}
                />
                <Button 
                    variant="contained" 
                    onClick={onApply}
                    size="small"
                >
                    Apply
                </Button>
            </Box>
        </LocalizationProvider>
    );
}
